<mat-tab-group>
  <mat-tab label="Active Campaigns">
    <app-mat-data-grid
      class="page-data-grid"
      [formValid]="form.valid"
      [(dataSource)]="filteredData"
      [displayedColumns]="[
        'name',
        'campaignType',
        'experienceType',
        'phoneNumber',
        'language',
        'queue',
        'whisper',
        'customPrompt',
        'enabled'
      ]"
      [columnNames]="[
        'Campaign Name',
        'Campaign Type',
        'Experience Type',
        'Phone Number',
        'Language',
        'Queue',
        'Agent Whisper',
        'Custom Prompt',
        'Enabled'
      ]"
      [editDefinition]="{
        name: name,
        campaignType: type,
        experienceType: experienceType,
        phoneNumber: phoneNumber,
        language: language,
        queue: queue,
        whisper: whisper,
        customPrompt: customPrompt,
        enabled: enabled
      }"
      [columnFormatters]="{'phoneNumber': formatPhoneNumberFunction,'language': formatLanguageFunction,'queue':formatQueueFunction}"
      [pageSizeOptions]="[5, 10, 15]"
      [buttonConfig]="{
        edit: { show: editable },
        delete: { show: false },
        create: { show: editable },
        loading: { show: true,  template: loading}
      }"
      [objectBluePrint]="{ enabled: true, type: 'campaign'}"
      (buttonClick)="handleButtonEvent($event)"
    >
    </app-mat-data-grid>
    <ng-template  #loading>
      <mat-spinner *ngIf="!editable" diameter=50></mat-spinner>
    </ng-template>
    <ng-template let-element #name>
      <form [formGroup]="form" [hidden]="!creatingRow">
        <input
          type="text"
          [(ngModel)]="element.name"
          placeholder="Campaign Name"
          formControlName="name"
        />
      </form>
      <span *ngIf="!creatingRow">
        {{element.name}}
    </span>
    </ng-template>
    <ng-template let-element #type>
      <form [formGroup]="form">
        <select [(ngModel)]="element.campaignType" formControlName="campaignType">
          <option value="" disabled selected hidden>Select Type</option>
          <option
            class="custom-option"
            *ngFor="let campaignType of campaignTypes"
            [ngValue]="campaignType"
          >
            {{ campaignType }}
          </option>
        </select>
      </form>
    </ng-template>
    <ng-template let-element #experienceType>
        <form [formGroup]="form">
          <select [(ngModel)]="element.experienceType" formControlName="experienceType">
            <option value="" disabled selected hidden>Select Experience Type</option>
            <option
              class="custom-option"
              *ngFor="let experienceType of experienceTypes"
              [ngValue]="experienceType"
            >
              {{ experienceType }}
            </option>
          </select>
        </form>
      </ng-template>
    <ng-template let-element #phoneNumber>
      <form [formGroup]="form" [hidden]="!creatingRow">
        <input
          type="text"
          [(ngModel)]="element.phoneNumber"
          placeholder="Phone Number"
          formControlName="phoneNumber"
          (blur)="validatePhoneNumber(element.phoneNumber)"
        />
      </form>
      <span *ngIf="!creatingRow">
        {{displayFormatPhoneNumber(element.phoneNumber)}}
    </span>
    </ng-template>
    <ng-template let-element #language>
      <form [formGroup]="form">
        <select [(ngModel)]="element.language" formControlName="language">
          <option value="" disabled selected hidden>Select Language</option>
          <option
            class="custom-option"
            *ngFor="let language of languages"
            [ngValue]="language[1]"
          >
            {{ language[0] }}
          </option>
        </select>
      </form>
    </ng-template>
    <ng-template let-element #enabled>
        <mat-slide-toggle [(ngModel)]="element.enabled"
          >Enabled</mat-slide-toggle
        >
    </ng-template>
    <ng-template let-element #queue>
      <form [formGroup]="form">
        <select [(ngModel)]="element.queue" formControlName="queue">
          <option value="" disabled selected hidden>Select queue</option>
          <option
            class="custom-option"
            *ngFor="let queue of queues"
            [ngValue]="queue"
          >
            {{ queue.queueName }}
          </option>
        </select>
      </form>
    </ng-template>
    <ng-template let-element #whisper>
      <form [formGroup]="form">
        <input
          type="text"
          [(ngModel)]="element.whisper"
          placeholder="Whisper"
          formControlName="whisper"
        />
      </form>
    </ng-template>
    <ng-template let-element #customPrompt>
      <form [formGroup]="form">
        <textarea
          type="text"
          placeholder="Custom Prompt"
          [(ngModel)]="element.customPrompt"
          formControlName="customPrompt"
        ></textarea>
      </form>
    </ng-template>
  </mat-tab>
  <mat-tab label="Ended Campaigns">
    <app-mat-data-grid
      class="page-data-grid"
      [formValid]="form.valid"
      [(dataSource)]="inactiveData"
      [displayedColumns]="[
        'name',
        'campaignType',
        'experienceType',
        'phoneNumber',
        'language',
        'queue',
        'whisper',
        'customPrompt',
        'enabled',
        'created',
        'creator',
        'lastUpdated',
        'updatedBy'
      ]"
      [columnNames]="[
        'Campaign Name',
        'Campaign Type',
        'Experience Type',
        'Phone Number',
        'Language',
        'Queue',
        'Agent Whisper',
        'Custom Prompt',
        'Enabled',
        'Created',
        'Creator',
        'Last Updated',
        'Updated By'
      ]"
      [columnFormatters]="{'phoneNumber': formatPhoneNumberFunction,'language': formatLanguageFunction,'queue':formatQueueFunction}"
      [pageSizeOptions]="[5, 10, 15]"
      [buttonConfig]="{
        edit: { show: false },
        delete: { show: false },
        create: { show: false }
      }"
      (buttonClick)="handleButtonEvent($event)"
    >
    </app-mat-data-grid>
  </mat-tab>
  <mat-tab label="KPI">
      <app-mat-data-grid
        class="page-data-grid"
        [formValid]="kpiForm.valid"
        [(dataSource)]="kpiData"
        [displayedColumns]="[
          'phoneNumber',
          'name',
          'queue',
          'department',
          'whisper',
          'enabled'
        ]"
        [columnNames]="[
          'Phone Number',
          'DNIS Name',
          'Queue',
          'Department',
          'Whisper',
          'Enabled'
        ]"
        [editDefinition]="{
          phoneNumber: kpiPhoneNumber,
          name: kpiName,
          queue:kpiQueue,
          department: department,
          whisper: kpiWhisper,
          enabled: enabled
        }"
        [columnFormatters]="{'phoneNumber': formatPhoneNumberFunction, 'queue':formatQueueFunction}"
        [pageSizeOptions]="[5, 10, 15]"
        [buttonConfig]="{
          edit: { show: editable },
          delete: { show: false },
          create: { show: true },
          loading: { show: true,  template: loading}
        }"
        [objectBluePrint]="{ enabled: true, type: 'kpi' }"
        (buttonClick)="handleKPIButtonEvent($event)"
      >
      </app-mat-data-grid>
      <ng-template  #loading>
        <mat-spinner *ngIf="!editable" diameter=50></mat-spinner>
      </ng-template>
     
      <ng-template let-element #kpiPhoneNumber>
        <form [formGroup]="kpiForm" [hidden]="!creatingRow">
          <input
            type="text"
            [(ngModel)]="element.phoneNumber"
            placeholder="Phone Number"
            formControlName="kpiPhoneNumber"
            (blur)="validateKPIPhoneNumber(element.phoneNumber)"
          />
        </form>
        <span *ngIf="!creatingRow">
          {{displayFormatPhoneNumber(element.phoneNumber)}}
        </span>
      </ng-template>

      <ng-template let-element #kpiName>
        <form [formGroup]="kpiForm" [hidden]="!creatingRow">
          <input
            type="text"
            [(ngModel)]="element.name"
            placeholder="DNIS Name"
            formControlName="kpiName"
          />
        </form>
        <span *ngIf="!creatingRow">
          {{element.name}}
      </span>
      </ng-template>

      <ng-template let-element #kpiQueue>
        <form [formGroup]="kpiForm">
          <select [(ngModel)]="element.queue" formControlName="kpiQueue">
            <option value="" disabled selected hidden>Select Queue</option>
            <option
              class="custom-option"
              *ngFor="let queue of kpiQueues"
              [ngValue]="queue"
            >
              {{ queue.queueName }}
            </option>
          </select>
        </form>
      </ng-template>

      <ng-template let-element #department>
        <form [formGroup]="kpiForm">
          <select [(ngModel)]="element.department" formControlName="department">
            <option value="" disabled selected hidden>Select Department</option>
            <option
              class="custom-option"
              *ngFor="let department of departments"
              [ngValue]="department"
            >
              {{ department }}
            </option>
            <option class="custom-option" [ngValue]="null">None</option>
          </select>
        </form>
      </ng-template>

      <ng-template let-element #kpiWhisper>
        <form [formGroup]="kpiForm">
          <input
            type="text"
            [(ngModel)]="element.whisper"
            placeholder="Whisper"
            formControlName="kpiWhisper"
          />
        </form>
      </ng-template>

  </mat-tab>
</mat-tab-group>
